import { tns } from 'tiny-slider/src/tiny-slider';

class BannerStatsSlider {
	constructor(el) {
		this.el = el;

		this.slider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: 'gallery',
			autoplay: false,
			loop: false,
			autoplayButtonOutput: false,
			speed: 600,
			controls: false,
			nav: true,
			navPosition: 'bottom',
		});

		this.wrapper = this.el.closest('.tns-outer') || this.el.parentElement;
		this.slides = Array.from(this.wrapper.querySelectorAll('.banner-default__stat-slide'));

		this.handleIndexChanged = () => this.updateSlideStates();

		this.updateSlideStates();
		this.slider.events.on('indexChanged', this.handleIndexChanged);
	}

	updateSlideStates() {
		this.slides.forEach((slide) => {
			const isActive = slide.classList.contains('tns-slide-active');

			if (isActive) {
				slide.removeAttribute('inert');
			} else {
				if (document.activeElement && slide.contains(document.activeElement)) {
					document.activeElement.blur();
				}
				slide.setAttribute('inert', '');
			}
		});
	}

	destroy() {
		if (this.slider) {
			this.slider.events.off('indexChanged', this.handleIndexChanged);
			this.slider.destroy();
		}
	}
}

export default BannerStatsSlider;
